import OnlineBilling from '../../Images/landing-page/online-billing-icon.png'
import EasyScheduling from '../../Images/landing-page/easy-scheduling-icon.png'
import CustomerTracking from '../../Images/landing-page/customer-tracking-icon.png'

export const SuccessData = [
    {   rate: '15k+',
        description: 'Students'
    },

    {   rate: '75%',
        description: 'Total success'
    },

    {   rate: '35',
        description: 'Main questions'
    },

    {   rate: '26',
        description: 'Chief experts'
    },

    {   rate: '16',
        description: 'Years of experience'
    },
]

export const CloudData = [
    {
        img: OnlineBilling,
        topic: 'Online Billing, Invoicing, & Contracts',
        description: 'Simple and secure control of your organization’s financial and legal transactions. Send customized invoices and contracts'
    },

    {
        img: EasyScheduling,
        topic: 'Easy Scheduling & Attendance Tracking',
        description: 'Schedule and reserve classrooms at one campus or multiple campuses. Keep detailed records of student attendance'
    },

    {
        img: CustomerTracking,
        topic: 'Customer Tracking',
        description: 'Automate and track emails to individuals or groups. Skilline’s built-in system helps organize your organization '
    }
]